<template>
  <div class="page">
    <div class="card">
      <h1>Kontakt</h1>
      <p class="lead">
        Vielen Dank, dass Sie sich für meine Fotografie interessieren.
        Wenn Sie ein Bild erwerben möchten, schreiben Sie mir einfach eine E-Mail.
      </p>

      <div class="grid">
        <section class="box">
          <h2>Direktkontakt</h2>
          <div class="kv">
            <div class="k">E-Mail</div>
            <div class="v">
              <a class="link" href="mailto:hardt.jim@gmail.com">hardt.jim@gmail.com</a>
            </div>

            <div class="k">Telefon</div>
            <div class="v">
              <a class="link" href="tel:+352691624657">+352 691 624 657</a>
            </div>
          </div>

          <div class="actions">
            <a class="btn" :href="mailtoHref">E-Mail schreiben</a>
            <a class="btn ghost" href="mailto:hardt.jim@gmail.com">Mail-App öffnen</a>
          </div>
        </section>

        <section class="box">
          <h2>So funktioniert’s</h2>
          <ol class="steps">
            <li>Öffnen Sie in der Galerie das gewünschte Foto.</li>
            <li>Notieren Sie die <b>Foto-Nummer</b> unter dem vergrößerten Bild.</li>
            <li>Senden Sie mir eine E-Mail mit der Foto-Nummer und Ihrer Anfrage.</li>
          </ol>

          <p class="muted">
            Ich melde mich schnellstmöglich zurück, um alle Details zu besprechen.
          </p>
        </section>
      </div>

      <div class="note">
        <div class="badge">Tipp</div>
        <p>
          Je genauer Ihre Nachricht (Foto-Nummer, gewünschte Größe/Format, Verwendungszweck),
          desto schneller kann ich Ihnen ein passendes Angebot machen.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    mailtoHref() {
      const subject = encodeURIComponent('Anfrage Foto (Bitte Foto-Nummer angeben)')
      const body = encodeURIComponent(
        `Hallo Jean-Marie,\n\n` +
        `ich interessiere mich für folgendes Foto:\n` +
        `Foto-Nummer: \n\n` +
        `Gewünschtes Format/Größe (optional): \n` +
        `Verwendungszweck (optional): \n\n` +
        `Viele Grüße\n`
      )
      return `mailto:hardt.jim@gmail.com?subject=${subject}&body=${body}`
    }
  }
}
</script>

<style scoped>
.page{
  max-width:1000px;
  margin:40px auto;
  padding:0 16px;
  color:#fff;
}

.card{
  background:rgba(255,255,255,.04);
  border:1px solid rgba(255,255,255,.08);
  border-radius:14px;
  padding:24px;
}

h1{
  margin:0 0 10px;
  font-size:28px;
  letter-spacing:.2px;
}

.lead{
  margin:0 0 18px;
  opacity:.85;
  line-height:1.7;
}

.grid{
  display:grid;
  grid-template-columns:1fr 1.2fr;
  gap:12px;
}

.box{
  background:rgba(0,0,0,.35);
  border:1px solid rgba(255,255,255,.08);
  border-radius:14px;
  padding:14px;
}

h2{
  margin:0 0 10px;
  font-size:16px;
  opacity:.9;
}

.kv{
  display:grid;
  grid-template-columns:90px 1fr;
  gap:8px 12px;
  align-items:start;
}

.k{opacity:.7}
.v{line-height:1.6}

.link{
  color:#00aeff;
  text-decoration:none;
  font-weight:700;
}

.link:hover{opacity:.9}

.actions{
  display:flex;
  gap:10px;
  flex-wrap:wrap;
  margin-top:12px;
}

.btn{
  display:inline-flex;
  align-items:center;
  justify-content:center;
  padding:10px 12px;
  border-radius:10px;
  border:1px solid rgba(255,255,255,.14);
  background:#00aeff;
  color:#001018;
  text-decoration:none;
  font-weight:800;
  cursor:pointer;
}

.btn:hover{filter:brightness(1.05)}
.btn.ghost{background:transparent;color:#fff}

.steps{
  margin:0;
  padding-left:18px;
  line-height:1.8;
  opacity:.9;
}

.steps li{margin:6px 0}

.muted{
  margin:10px 0 0;
  opacity:.75;
  line-height:1.7;
}

.note{
  margin-top:14px;
  display:flex;
  gap:12px;
  align-items:flex-start;
  padding:12px 14px;
  border-radius:14px;
  border:1px solid rgba(255,255,255,.08);
  background:rgba(255,255,255,.03);
}

.badge{
  flex:0 0 auto;
  font-size:12px;
  font-weight:800;
  padding:6px 10px;
  border-radius:999px;
  border:1px solid rgba(255,255,255,.14);
  background:rgba(0,174,255,.12);
  color:#9fe3ff;
}

.note p{
  margin:0;
  opacity:.85;
  line-height:1.7;
}

@media (max-width:900px){
  .grid{grid-template-columns:1fr}
  .kv{grid-template-columns:80px 1fr}
}
</style>